var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('icon',[_c('ship',{attrs:{"transform":"translate(0 2) scale(3)"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }